import SyncWithPlayerStrategy from './SyncWithPlayerStrategy';

export default SyncWithPlayerStrategy;
